import Image from 'next/image';
import { cn } from '@/lib/utils';

/** Le logo seul, dans sa pastille blanche. */
export function Mark({
  size = 34,
  onLight = false,
  className,
}: {
  size?: number;
  /** Ombre discrète sur fond clair, marquée sur fond sombre. */
  onLight?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden bg-white',
        onLight ? 'shadow-mark-light' : 'shadow-mark',
        className,
      )}
      style={{ width: size, height: size, borderRadius: size * 0.28 }}
    >
      <Image
        src="/logo-icone.png"
        alt=""
        width={size}
        height={size}
        className="h-full w-full object-contain"
      />
    </span>
  );
}

/** « Ton » dans la couleur du fond, « Monni » en vert. */
export function Wordmark({ dark = false, className }: { dark?: boolean; className?: string }) {
  return (
    <span
      className={cn(
        'font-display text-[22px] leading-none font-extrabold tracking-[-0.5px]',
        className,
      )}
    >
      <span className={dark ? 'text-white' : 'text-navy'}>Ton</span>
      <span className="text-green">Monni</span>
    </span>
  );
}

/** Logo + nom, la signature de marque utilisée dans la sidebar, l'en-tête et la landing. */
export function Brand({
  dark = false,
  size = 34,
  className,
}: {
  dark?: boolean;
  size?: number;
  className?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-[9px]', className)}>
      <Mark size={size} onLight={!dark} />
      <Wordmark dark={dark} />
    </span>
  );
}
